import './App.css';
import Dashboard from './pages/dashboard';
import Menu from './components/menu';
import AddingData from './pages/AddingData';
import "./global.scss";
import Paper from './pages/Paper.jsx';
import Feedback from './pages/Feedback.jsx';
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from '@vercel/speed-insights/react';
import {
  Route,
  Routes,
  BrowserRouter,
  Navigate,
} from "react-router-dom";
import NotFound from './pages/NotFound';
import Signingforms from './pages/Signingforms';
import { useEffect, useState } from 'react';
import LandingPage from './pages/LandingPage.jsx';
import About from './pages/AboutUs.jsx';
import Admin from './pages/Admin.jsx';
import { useAtom } from 'jotai';
import { userAtom } from './atom.js';
import CustomFooter from './components/footer';
import CuirateNotice from './components/CuirateNotice';

const AUTHORIZED_ADMINS = [
  "muhammadsaboor119@gmail.com",
  "asfar.abid.chaudhay@gmail.com",
  "msargames119@gmail.com"
];

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const currentUser = useAtom(userAtom)?.[0];

  useEffect(() => {
    setIsAdmin(currentUser && AUTHORIZED_ADMINS.includes(currentUser?.email));
  }, [currentUser]);

  const ProtectedRoute = ({ children }) => {
    if (!currentUser) return <Navigate to="/signin" />;
    if (!AUTHORIZED_ADMINS.includes(currentUser?.email)) return <Navigate to="/" />;
    return children;
  };

  return (
    <BrowserRouter>
      <Menu isAdmin={isAdmin} />
      <div className="nav-spacer" />
      <main className="app-content">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<Dashboard isAdmin={isAdmin} />} />
          <Route path="/paper" element={<Paper />} />
          <Route path="/signin" element={<Signingforms />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/about" element={<About />} />
          <Route path="/admin" element={
            <ProtectedRoute><Admin isAdmin={isAdmin} /></ProtectedRoute>
          } />
          <Route path="/addData" element={
            <ProtectedRoute><AddingData isAdmin={isAdmin} /></ProtectedRoute>
          } />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <CustomFooter />
      <CuirateNotice />
      <Analytics />
      <SpeedInsights />
    </BrowserRouter>
  );
}

export default App;
